// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__ENNye","contextHolder":"contextHolder__B9B5i","context":"context__pgqfc"};